import { useEffect, useState } from "react";
import { ChartBar } from "@phosphor-icons/react";
import client from "../lib/api";

export const NudgeEffectivenessCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    client.get("/admin/nudge-effectiveness").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.count) return null;

  return (
    <div className="mt-6 card-surface p-4" data-testid="nudge-effectiveness-card">
      <div className="flex items-center gap-2 mb-3">
        <ChartBar size={14} weight="bold" color="#a78bfa" />
        <span className="overline">NUDGE EFFECTIVENESS · WHICH EMAILS MOVE LEADS</span>
      </div>
      <div className="space-y-2">
        {data.rows.map((r) => (
          <div key={r.key} data-testid={`nudge-eff-row-${r.key}`} className="flex items-center gap-3">
            <span className="text-[11px] text-neutral-300 w-40 shrink-0 truncate">{r.label}</span>
            <div className="flex-1 h-2 rounded-full bg-white/5 overflow-hidden">
              <div
                className={`h-full rounded-full ${r.rate >= 50 ? "bg-emerald-400" : r.rate >= 20 ? "bg-amber-400" : "bg-white/20"}`}
                style={{ width: `${Math.max(2, r.rate)}%` }}
              />
            </div>
            <span className="text-[10px] font-mono text-neutral-400 w-24 text-right shrink-0">
              {r.moved}/{r.sent} · <span className={r.rate >= 50 ? "text-emerald-300" : "text-neutral-300"}>{r.rate}%</span>
            </span>
          </div>
        ))}
      </div>
      <div className="text-[10px] text-neutral-500 mt-3">
        "Moved" = replied, signed up, won, or completed the stuck milestone after the email landed.
      </div>
    </div>
  );
};
